import Error from '@/pages/error';

import { getInitialProps } from '@/lib/graphql/api';
import { PageQuery } from '@/lib/graphql/querys';

function PageError() {
  return <Error error="50X" />;
}

export async function getStaticProps() {
  const query = PageQuery();
  return await getInitialProps(query, { slug: '500-2' });
}

export default PageError;
